import React, { useEffect } from "react";
import OurLawyers from "./OurLawyers";
import OurA from "./OurA";
import AOS from "aos";
import "aos/dist/aos.css";
import Ourteamabout from "./Ourteamabout";
const OurTeam = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
  }, []);
  return (
    <div>
      {/* HERO SECTION */}
      <section className="about-hero" data-aos="fade-up">
        {/* BLURRED IMAGE LAYER */}
        <div className="hero-bg"></div>

        {/* CONTENT (NOT BLURRED) */}
        <div className="hero-content text-center text-white">
          <div className="container-fluid">
            <h1 className="fw-bold text-white">Our Team</h1>
            <p className="mt-3">
              A leading national law firm delivering strategic, trusted legal
              solutions
            </p>
          </div>
        </div>
      </section>
      <Ourteamabout/>
      <OurLawyers />
      <OurA />
    </div>
  );
};

export default OurTeam;
